export default "__VITE_ASSET__rt2ToSKE__ 1032w, __VITE_ASSET__ZfsAJD7$__ 1000w, __VITE_ASSET__AL$7PzQo__ 767w, __VITE_ASSET__bI24A3L8__ 500w";